import { render, staticRenderFns } from "./EvaluateContent.vue?vue&type=template&id=684bbd15&scoped=true"
import script from "./EvaluateContent.vue?vue&type=script&lang=js"
export * from "./EvaluateContent.vue?vue&type=script&lang=js"
import style0 from "./EvaluateContent.vue?vue&type=style&index=0&id=684bbd15&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684bbd15",
  null
  
)

export default component.exports